export default "__VITE_PUBLIC_ASSET__a87b32c7__"